import { render } from "./IntroStep.vue?vue&type=template&id=fd4dceb8"
import script from "./IntroStep.vue?vue&type=script&lang=ts"
export * from "./IntroStep.vue?vue&type=script&lang=ts"
script.render = render

export default script